export default {
  textTransform: 'uppercase',
};
